export enum PlatformType {
  IN_FRAME = 0,
  NOT_IN_FRAME = 1
}
